import React, { useEffect } from "react";
import { getContentUrl, ContentURL } from "../../Utils/ContentURL";
import { Button } from "@mui/material";
import { useAppState } from "../../../Redux/ReduxHooks";
import { BookingDataOwnership, BookingStatus } from "../../../Services/BookingEntities";
import { GetValues } from "../../../Config/MyAppConfig";
import { GetBrandedUrl, BrandedImage } from "../../Utils/BrandedContentUrls";

/**
 * Displays the driver details if the booking is accepted by a driver.
 */
export const DriverDetailsSection: React.FC = () => {

    const bookingDetails = useAppState(state => state.PhoneToCnp.Booking)!;

    useEffect(() => {
        if (bookingDetails.TrackingInfo.BookingStatusID < BookingStatus.Accepted) return;
        if (bookingDetails.TrackingInfo.BookingStatusID == BookingStatus.Cancelled || bookingDetails.TrackingInfo.BookingStatusID > BookingStatus.NoJob) return;
    }, [bookingDetails, bookingDetails?.TrackingInfo.BookingStatusID]);

    if (bookingDetails.TrackingInfo.BookingStatusID < BookingStatus.Accepted) return null;
    if (bookingDetails.TrackingInfo.BookingStatusID == BookingStatus.Cancelled || bookingDetails.TrackingInfo.BookingStatusID > BookingStatus.NoJob) return null;

    const driverImageUrl = bookingDetails.TrackingInfo.DriverImage ?? GetBrandedUrl(BrandedImage.DriverDummy);

    return (
        <div className="driver-and-vehicle-details-section">
            <div className="driver-and-vehicle-details">
                <div className="driver-details">
                    <div><img className="driver-photo" src={driverImageUrl} /></div>
                    <div className="driver-info">
                        <div>
                            <img src={getContentUrl(ContentURL.images.PhoneToCnp.TaxiImage)} />
                            <span>{bookingDetails.TrackingInfo.TaxiFleetName}</span>
                        </div>
                        <div>
                            <img src={getContentUrl(ContentURL.images.PhoneToCnp.DriverIcon)} />
                            <span>{bookingDetails.TrackingInfo.DriverName}</span>
                        </div>
                    </div>
                </div>
                <div className="vehicle-details">
                    <div className="taxi-number">{bookingDetails.TrackingInfo.CarNumber}</div>
                    <div className="taxi-number-label">Taxi plate</div>
                </div>
            </div>
            {bookingDetails.TrackingInfo.BookingStatusID < BookingStatus.Completed && bookingDetails.DataOwnership === BookingDataOwnership.WritableLink && <Button variant="outlined" className="action-btn call-driver-btn" onClick={() => { window.location.href = `tel://${GetValues().DriverConnectNumber}`; }}><img src={getContentUrl(ContentURL.images.PhoneToCnp.PhoneIcon)} /><span>Contact driver</span></Button>}
        </div>
    )
}